import BaseView from './BaseView';

import SectionGroups from '../components/SectionGroups';
import Accordion from '../components/Accordion';
import CarouselPages from '../components/CarouselPages';
import CarouselImages from '../components/CarouselImages';
import CarouselProgrammes from '../components/CarouselProgrammes';
import TwoProgrammes from '../components/TwoProgrammes';
import Menu from '../components/Menu';
import Wysiwyg from '../components/Wysiwyg';
import VideoText from '../components/VideoText';
import LottieAnimation from '../components/LottieAnimation';
import VideoPlayer from '../components/VideoPlayer';
import ModuleBackground from '../components/ModuleBackground';
import CardInView from '../components/CardInView';
import Programmes from '../components/Programmes';
import Articles from '../components/Articles';
import Courses from '../components/Courses';
import VideoStory from '../components/VideoStory';
import Gallery from '../components/Gallery';
import Showcase from '../components/Showcase';
import ImgTextBlocks from '../components/ImgTextBlocks';
import CarouselData from '../components/CarouselData';
import HeroProgramme from '../components/HeroProgramme';

let view = null;

class Default extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const groups = new Map([
			[SectionGroups, this.container.querySelectorAll('.section-group')],
			[VideoPlayer, this.container.querySelectorAll('[data-video-wrapper]')],
			[Accordion, this.container.querySelectorAll('[data-accordion]')],
			[CarouselPages, this.container.querySelectorAll('[data-carousel-pages]')],
			[CarouselImages, this.container.querySelectorAll('[data-carousel-images]')],
			[CarouselProgrammes, this.container.querySelectorAll('[data-carousel-programmes]')],
			[Menu, this.container.querySelectorAll('.c-header-wrapper')],
			[TwoProgrammes, this.container.querySelectorAll('[data-two-programmes]')],
			[Wysiwyg, this.container.querySelectorAll('.wysiwyg')],
			[VideoText, this.container.querySelectorAll('.m-media-text--video, .m-hero--video, .m-media-media--video')],
			[LottieAnimation, this.container.querySelectorAll('[data-lottie-animation]')],
			[ModuleBackground, this.container.querySelectorAll('[data-module-background]')],
			[CardInView, this.container.querySelectorAll('[data-card-in-view]')],
			[Programmes, this.container.querySelectorAll('[data-programmes]')],
			[Articles, this.container.querySelectorAll('[data-articles-overview]')],
			[Courses, this.container.querySelectorAll('[data-module-courses]')],
			[VideoStory, this.container.querySelectorAll('[data-video-story]')],
			[Gallery, this.container.querySelectorAll('[data-gallery]')],
			[Showcase, this.container.querySelectorAll('[data-showcase]')],
			[ImgTextBlocks, this.container.querySelectorAll('[data-img-text-blocks]')],
			[CarouselData, this.container.querySelectorAll('[data-carousel-data]')],
			[HeroProgramme, this.container.querySelectorAll('[data-hero-programme]')],
		]);

		super.createModules(groups);
	}
}

export default {
	namespace: 'default',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Default(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
